import { isSameDomainGameLaunchPath } from './game-play-path';
import type { LauncherUrlResolutionContext } from './launcher-url';

export enum GameLaunchMode {
    REDIRECT = 'redirect',
    POPUP = 'popup',
    EMBED = 'embed'
}

export type GameLaunchModeContext = LauncherUrlResolutionContext & {
    isMobile: boolean;
    isAndroidWrapper: boolean;
    isIosWrapper: boolean;
    isDesktop: boolean;
};

const isSameDomainLauncherUrl = (launcherUrl: string): boolean => {
    try {
        const { pathname } = new URL(launcherUrl, typeof window !== 'undefined' ? window.location.origin : undefined);
        return isSameDomainGameLaunchPath(pathname);
    } catch {
        return false;
    }
};

export const getGameLaunchMode = (launcherUrl: string, ctx: GameLaunchModeContext): GameLaunchMode => {
    if (!ctx.shouldUseSameDomainLauncher && !isSameDomainLauncherUrl(launcherUrl)) {
        return GameLaunchMode.POPUP;
    }

    if (ctx.isMobile && !ctx.isAndroidWrapper && !ctx.isIosWrapper && !ctx.isDesktop) {
        return GameLaunchMode.REDIRECT;
    }

    if (ctx.isDesktop) {
        return GameLaunchMode.EMBED;
    }

    return GameLaunchMode.REDIRECT;
};
